import { Formatter } from "@stamhoofd/utility";
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Unknown"] = "Unknown";
    PaymentMethod["PointOfSale"] = "PointOfSale";
    PaymentMethod["Transfer"] = "Transfer";
    PaymentMethod["DirectDebit"] = "DirectDebit";
    PaymentMethod["Bancontact"] = "Bancontact";
    PaymentMethod["iDEAL"] = "iDEAL";
    PaymentMethod["Payconiq"] = "Payconiq";
    PaymentMethod["CreditCard"] = "CreditCard";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentMethodV150;
(function (PaymentMethodV150) {
    PaymentMethodV150["Unknown"] = "Unknown";
    PaymentMethodV150["Transfer"] = "Transfer";
    PaymentMethodV150["DirectDebit"] = "DirectDebit";
    PaymentMethodV150["Bancontact"] = "Bancontact";
    PaymentMethodV150["iDEAL"] = "iDEAL";
    PaymentMethodV150["Payconiq"] = "Payconiq";
    PaymentMethodV150["CreditCard"] = "CreditCard";
})(PaymentMethodV150 || (PaymentMethodV150 = {}));
export function downgradePaymentMethodV150(newerValue) {
    if (newerValue === PaymentMethod.PointOfSale) {
        return PaymentMethodV150.Transfer;
    }
    return newerValue;
}
export function downgradePaymentMethodArrayV150(newerValue) {
    return newerValue.map(v => downgradePaymentMethodV150(v));
}
export class PaymentMethodHelper {
    static getName(method, context = null) {
        switch (method) {
            case PaymentMethod.Unknown: return "onbekende betaalmethode";
            case PaymentMethod.PointOfSale: {
                switch (context) {
                    case "takeout": return "bij afhalen";
                    case "delivery": return "bij levering";
                    case "Takeout": return "bij afhalen";
                    case "Delivery": return "bij levering";
                    case "OnSite": return "ter plaatse";
                    default: return "ter plaatse";
                }
            }
            case PaymentMethod.Transfer: return "overschrijving";
            case PaymentMethod.DirectDebit: return "domiciliëring";
            case PaymentMethod.Bancontact: return "Bancontact";
            case PaymentMethod.iDEAL: return "iDEAL";
            case PaymentMethod.CreditCard: return "kredietkaart";
            case PaymentMethod.Payconiq: return "Payconiq by Bancontact";
        }
    }
    static getPluralName(method) {
        switch (method) {
            case PaymentMethod.Unknown: return "onbekende betaalmethodes";
            case PaymentMethod.PointOfSale: {
                return 'betalingen ter plaatse';
            }
            case PaymentMethod.Transfer: return "overschrijvingen";
            case PaymentMethod.DirectDebit: return "domiciliëringen";
            case PaymentMethod.Bancontact: return "Bancontact betalingen";
            case PaymentMethod.iDEAL: return "iDEAL betalingen";
            case PaymentMethod.CreditCard: return "kredietkaart betalingen";
            case PaymentMethod.Payconiq: return "Payconiq betalingen";
        }
    }
    static getNameCapitalized(method, context = null) {
        return Formatter.capitalizeFirstLetter(PaymentMethodHelper.getName(method, context));
    }
}
//# sourceMappingURL=PaymentMethod.js.map